var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.989,
    height: 10.481,
    viewBox: "0 0 9.989 10.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ef2654;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.055,15.365H22.333v-.55A1.014,1.014,0,0,0,21.32,13.8H19.67a1.013,1.013,0,0,0-1.013,1.013v.55H15.934a.434.434,0,0,0,0,.869h.883V22.69a1.592,1.592,0,0,0,1.592,1.592h4.169a1.592,1.592,0,0,0,1.592-1.592V16.233h.883a.434.434,0,0,0,0-.869Zm-5.53-.55a.144.144,0,0,1,.145-.145h1.65a.145.145,0,0,1,.145.145v.55h-1.94Zm3.764,7.89a.724.724,0,0,1-.724.724H18.41a.724.724,0,0,1-.724-.724V16.234H23.3Z",
    transform: "translate(-15.5 -13.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.934,42.3a.434.434,0,0,0,.434-.434V37.536a.434.434,0,0,0-.869,0v4.328A.434.434,0,0,0,54.934,42.3Z",
    transform: "translate(-48.854 -33.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.934,42.3a.434.434,0,0,0,.434-.434V37.536a.434.434,0,0,0-.869,0v4.328A.434.434,0,0,0,39.934,42.3Z",
    transform: "translate(-36.025 -33.729)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoTrash);
export default __webpack_public_path__ + "static/media/picto-trash.c278a3c98d93680cc7c64a428c752d52.svg";
export { ForwardRef as ReactComponent };